"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.attributesSetValuesMap = exports.attributesSetAttributes = exports.attributesSetFormalAttributeValues = exports.attributesSetFormalAttributes = void 0;
const Actions = __importStar(require("../types/attributes"));
const utils_1 = require("../utils");
const attributesSetFormalAttributes = (attributes) => (0, utils_1.createAction)(Actions.ATTRIBUTES_SET_FORMAL_ATTRIBUTES, attributes);
exports.attributesSetFormalAttributes = attributesSetFormalAttributes;
const attributesSetFormalAttributeValues = (attributeValues) => (0, utils_1.createAction)(Actions.ATTRIBUTES_SET_FORMAL_ATTRIBUTE_VALUES, attributeValues);
exports.attributesSetFormalAttributeValues = attributesSetFormalAttributeValues;
const attributesSetAttributes = (payload) => (0, utils_1.createAction)(Actions.ATTRIBUTES_SET_ATTRIBUTES, payload);
exports.attributesSetAttributes = attributesSetAttributes;
const attributesSetValuesMap = (attributeValuesMap) => ((0, utils_1.createAction)(Actions.ATTRIBUTES_SET_VALUES_MAP, attributeValuesMap));
exports.attributesSetValuesMap = attributesSetValuesMap;
